import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

/*
 * The panel's stylesheets, in load order.
 *
 * `styles/ref` is the reference admin's own CSS carried over whole — its fonts, its tokens, its
 * base layer, its shell and every component sheet, unedited. The design is not approximated from
 * it; it IS it, with the two rebrand knobs turned to AWJ's espresso and brass.
 *
 * The storefront's token package and the kit's stylesheet are deliberately NOT loaded here. They
 * are a shop's palette and a shop's proportions, and this is a back office. What the admin still
 * uses out of @awj/ui — Button, TextField, Dialog, Skeleton, the toast host — is painted by
 * `kit-bridge.css` with the reference's own declarations, so a kit control and a reference
 * control are the same object on screen.
 *
 * `admin.css` is last and holds only what the reference has no component for: this shop's own
 * screens — the product editor, the order timeline, the enquiry inbox, the content studio.
 */
import './styles/ref/index.css';
import './styles/kit-bridge.css';
import './styles/admin.css';

import { App } from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
